function isElementNOTInArray(payload) {
  return !payload.array.find(
    (summaryEl) =>
      summaryEl[payload.item].trim() == payload.element[payload.item].trim()
  );
}

function isSelectedSoapCategory(payload, element){
  return (payload.soap.trim() == element.soap.trim()) || (payload.soap == "All Soaps");
}

export default {
  async topTenKillers(context, payload) {
    let summaryArray = [];

    // pull out each unique killer name from data per soap if specific soap
    // defined in payload if already in summary array increase count by 1
    context.state.MurderData.forEach((element, index) => {
     
      if (
        isElementNOTInArray({
          array: summaryArray,
          item: "killer",
          element: element,
          image: element.image
        })
      ) {
        if (isSelectedSoapCategory(payload, element)) {
          let victimArray = [];
          victimArray.push(element.victim);
          summaryArray.push({
            killer: element.killer,
            soap: element.soap,
            count: 1,
            image: element.image,
            victims : victimArray,
          });
        }
      } else if (isSelectedSoapCategory(payload, element)) {
        index = summaryArray.findIndex(
          (summaryEl) => summaryEl.killer == element.killer
        );
        summaryArray[index].count = summaryArray[index].count + 1;
        summaryArray[index].victims.push(element.victim);
      }
    });

    //order array in descending order by count and pull 'TopNumber' values from array
    summaryArray = summaryArray.sort((a, b) => b.count - a.count);
    let TopNumber = 5;
    if (context.state.killerSoap == "All Soaps") { TopNumber = 10;}
    context.commit("setTopTenKillers", {
      value: summaryArray.slice(0, TopNumber),
    });
  },

  async topTenMethods(context, payload) {
    let summaryArray = [];

    //pull out each unique murder method from data
    context.state.MurderData.forEach((element, index) => {
       

      if (
        isElementNOTInArray({
          array: summaryArray,
          item: "method",
          element: element,
        })
      ) {
        summaryArray.push({ method: element.method, count: 0 });
      } else {
        index = summaryArray.findIndex(
          (summaryEl) => summaryEl.method == element.method
        );
        summaryArray[index].count = summaryArray[index].count + 1;
      }
    });
    //count each method frequency per soap if specific soap defined in payload
    summaryArray.forEach((element, index) => {
      const methodCount = context.state.MurderData.filter((val) => {
        if (payload.soap === "All Soaps") {
          return val.method.trim().includes(element.method.trim());
        } else {
          return (
            val.method.trim().includes(element.method.trim()) &&
            val.soap.trim().includes(payload.soap.trim())
          );
        }
      });
      summaryArray[index].count = methodCount.length;
    });

    //order array in descending order by count
    summaryArray = summaryArray.sort((a, b) => b.count - a.count);
    const TopNumber=10;
    context.commit("setTopTenMethods", {
      value: summaryArray.slice(0, TopNumber),
    });
  },

  async murdersByDate(context, payload) {
    const dateType = payload.dateType;
    let summaryArray = [];
    let murderDateValue = 0;
    if (dateType == "month") { summaryArray = [
      {date:0, count:0},
      {date:1, count:0},
      {date:2, count:0},
      {date:3, count:0},
      {date:4, count:0},
      {date:5, count:0},
      {date:6, count:0},
      {date:7, count:0},
      {date:8, count:0},
      {date:9, count:0},
      {date:10, count:0},
      {date:11, count:0},]}
   
    //convert date into date object and replace in state object
    await context.state.MurderData.forEach((element, index) => {
      const murderDate = new Date(
        element.date.split("/")[2],
        element.date.split("/")[1] - 1,
        element.date.split("/")[0]
      );

      if (dateType == "month") {
        murderDateValue = murderDate.getMonth();
      } else {
        murderDateValue = murderDate.getFullYear();
      }

      if (
        !summaryArray.find((summaryEl) => summaryEl.date == murderDateValue)
      ) {
        if (isSelectedSoapCategory(payload, element)
        ) {
          summaryArray.push({
            date: murderDateValue,
            count: 1,
          });
        }
      } else if (isSelectedSoapCategory(payload, element)){
        index = summaryArray.findIndex(
          (summaryEl) => summaryEl.date == murderDateValue
        );
        summaryArray[index].count = summaryArray[index].count + 1;
      }
    });

    summaryArray = summaryArray.sort((a, b) => a.date - b.date);
    await context.commit("setMurderDates", { value: summaryArray });
  },
};

